module.exports={render:function (){with(this) {
  return _h('calendar')
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2deabe3c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 115
// module chunks = 2